import LogErrorFrontService from '@/api/LogErrorFrontService'

// automatically namespaced based on the path the module is registered
const namespaced = true

// initial state
const state = {
  logs: [],
}

// getters
const getters = {
  getState: state => (key) => {
    return state[key]
  },
}

// mutations
const mutations = {
  setState (state, data) {
    for (let key in data) {
      state[key] = data[key]
    }
  },
}

// actions
const actions = {
  async getAll ({ commit }) {
    var result = null
    try {
      // clear error
      this.dispatch('Error', null)

      let response = await LogErrorFrontService.getAll()

      result = response.data

      if (result.success) {
        commit('setState', {
          'logs': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/LogErrorFront.js